import React from 'react'

export default function NewCategory() {
  return (
    <div>NnewCategory</div>
  )
}
